import { configureStore } from '@reduxjs/toolkit';
import CardValidationSlice from './cardValidation/cardValidationSlice';
import EventSlice from './event/eventSlice';
import LoadingSlice from './loading/loadingSlice';

const store = configureStore({
  reducer: {
    events: EventSlice,
    loading: LoadingSlice,
    cardValidation: CardValidationSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export default store;
